import {useState, useEffect} from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Login from "./layout/pages/login/Login";
import ResetPW from "./layout/pages/login/ResetPW";
import DashPlatform from "./pages/DashPlatform";
import DashBrokerServer from "./pages/DashBrokerServer";
import DashFireStatus from "./pages/DashFireStatus";
import Dash from "./pages/Dash";
import ConfFacilities from "./pages/ConfFacilities";
import ConfGateway from "./pages/ConfGateway";
import ConfRepeater from "./pages/ConfRepeater";
import ConfSensor from "./pages/ConfSensor";
import ConfControlHistory from "./pages/ConfControlHistory";
import FaultStatus from "./pages/FaultStatus";
import FaultHistory from "./pages/FaultHistory";
import PerfGateway from "./pages/PerfGateway";
import PerfRepeater from "./pages/PerfRepeater";
import PerfSensor from "./pages/PerfSensor";
import PerfSystem from "./pages/PerfSystem";
import PerfBrokerServer from "./pages/PerfBrokerServer";
import TrafAbnormal from "./pages/TrafAbnormal";
import TrafHistory from "./pages/TrafHistory";
import UserAuth from "./pages/UserAuth";
import UserPermission from "./pages/UserPermission";
import UserTopic from "./pages/UserTopic";
import UserAccessHistory from "./pages/UserAccessHistory";
import SysSmsSettings from "./pages/SysSmsSettings";
import SysFirmware from "./pages/SysFirmware";
import SysSmsHistory from "./pages/SysSmsHistory";
import Sys119History from "./pages/Sys119History";
import SysFcltyDept from "./pages/SysFcltyDept";
import SysReport from "./pages/SysReport";
import SysReportReg from "./pages/subPages/SysReportReg";
import {getRealtimeFire} from "./api/apiClient";
import Swal from "sweetalert2";
import DashAuthSelect from "./pages/DashAuthSelect";
import ConfCmnctEqpmn from "./pages/ConfCmnctEqpmn";
import PerfCmnctEqpmn from "./pages/PerfCmnctEqpmn";
import UserSafetyManager from "./pages/UserSafetyManager";
import ConfSystem from "./pages/ConfSystem";
import FaultResult from "./pages/FaultResult";

const AppV2 = () => {

  /* Swal */
  const [stCheck, setCheck] = useState(0);
  useEffect(() => {
    let fireInterval;
    console.log('start checking');
    fireInterval = setInterval(updateFire, 10000);
    setCheck(fireInterval);
    console.log(fireInterval);
  }, [])

  const stopChecking = () => {
    console.log('stop')
    console.log(stCheck);
    clearInterval(stCheck);
    setCheck(0);
  }

  const [stFireStatus, setFireStatus] = useState([])

  const updateFire = () => {
    let prevAlarm = sessionStorage.getItem('ALARM_CACHE')
    if (sessionStorage.getItem('ACCESS_TOKEN') != null) {
      getRealtimeFire().then((resp) => {
        console.log(resp);
        if (resp.data.data !== undefined) {
          if (prevAlarm == resp.data.data.list[0]?.fire_no &&
          !isOnFireAlarm(resp.data.data.list[0]?.fire_no)) {
            console.log('no alarm');
          } else {
            console.log('change alarm');
            // console.log(prevAlarm);
            // console.log(resp.data.data.list[0].fire_no);
            setFireStatus(resp.data.data.list);
            sessionStorage.setItem('ALARM_CACHE', resp.data.data.list[0]?.fire_no);
          }

        }
      });
    } else {
      console.log('has no access token. ignore alert. (logout).');
    }
  }
  // atdrc_nm:"서초구"
  // fclty_nm:"STI(시뮬레이터용)"
  // fclty_no:10001
  // fire_no:7
  // ocrn_dt_str:"2022-12-14 21:17:00"

  useEffect(() => {
    showFireAlarm();
  }, [stFireStatus]);

  // 시나리오 요약.
  // 팝업은 중복이 불가하여 동시 화재 발생 시 하나에 표기함.
  // 그러나 액션은 1개이며, 동시에 여러 화재를 off 하는 것은 권장하지 않으므로
  // 여러개를 표기하더라도 그만 보기는 첫번째 화재에 대해서 세션 스토리지에 저장.

  const offFireAlarm = (fire_no) => {
    console.log(`[FIRE ALARM] Turn off. fire_no = ${fire_no}`);
    sessionStorage.setItem(`fire_no[${fire_no}]`, 'OFF');
  }

  const isOnFireAlarm = (fire_no) => {
    console.log(`[FIRE ALARM] Check fire alarm. fire_no = ${fire_no}`);
    if (sessionStorage.getItem(`fire_no[${fire_no}]`) == undefined) {
      return true;
    } else {
      return false;
    }
  }

  const showFireAlarm = () => {
    let isFire = false;
    let firstFireNo = 0;
    let html_header = '';
    let html_text = '';

    for (let i = 0; i < stFireStatus.length; i++) {
      if (isOnFireAlarm(stFireStatus[i].fire_no)) {
        html_header += `${stFireStatus[i].atdrc_nm} ${stFireStatus[i].fclty_nm} 화재 발생`
        html_text += `${stFireStatus[i].ocrn_dt_str} <br/>`;
        isFire = true;
        if (firstFireNo === 0) {
          firstFireNo = stFireStatus[i].fire_no;
        }
      }
    }

    if (isFire) {
      Swal.fire({
        title: html_header,
        icon: 'warning',
        html: html_text,
        width: 800,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: '그만 보기',
        denyButtonText: `확인`,
      }).then((result) => {
        if (result.isConfirmed) {
          offFireAlarm(firstFireNo);
        } else if (result.isDenied) {

        }
      });
    }
    console.log('check fire!!!!');
  };


  const prefix = 'ui';

  return (
      <BrowserRouter>
        <Routes>
          <Route path={`/`} element={<Login/>}/>
          <Route path={`/${prefix}/login`} element={<Login/>}/>
          <Route path={`/${prefix}/reset-pw`} element={<ResetPW/>}/>

          {/* 대시보드 */}
          <Route path={`/${prefix}/dash_platform`} element={<DashAuthSelect/>}/> {/* 대시보드 */}
          <Route path={`/${prefix}/broker-server`} element={<DashBrokerServer/>}/>
          <Route path={`/${prefix}/dash_fire-status`} element={<DashFireStatus/>}/> {/* 화재 현황 */}
          <Route path={`/${prefix}/dash`} element={<Dash/>}/> {/* 화재 현황 */}

          {/* 구성 관리 */}
          <Route path={`/${prefix}/conf_facilities`} element={<ConfFacilities/>}/> {/* 이동약자시설 */}
          <Route path={`/${prefix}/conf_cmnct-eqpmn`} element={<ConfCmnctEqpmn/>}/>{/* 유무선통신장비 */}
          <Route path={`/${prefix}/conf_gateway`} element={<ConfGateway/>}/> {/* 게이트웨이 */}
          <Route path={`/${prefix}/conf_sensor`} element={<ConfSensor/>}/> {/* 센서 장비 */}
          <Route path={`/${prefix}/conf_system`} element={<ConfSystem/>}/> {/* 시스템 */}
          {/*삭제예정*/}<Route path={`/${prefix}/conf_repeater`} element={<ConfRepeater/>}/> {/* 중계기 */}
          <Route path={`/${prefix}/conf_control-history`} element={<ConfControlHistory/>}/>

          {/* 장애관리 */}
          <Route path={`/${prefix}/fault-status`} element={<FaultStatus/>}/> {/* 장애 현황 */}
          <Route path={`/${prefix}/fault-history`} element={<FaultHistory/>}/> {/* 장애 이력 */}
          <Route path={`/${prefix}/fault-result`} element={<FaultResult/>}/> {/* 장애 조치 현황 */}

          {/* 성능 관리 */}
          <Route path={`/${prefix}/perf_cmnct-eqpmn`} element={<PerfCmnctEqpmn/>}/> {/* 유무선통신장비 */}
          <Route path={`/${prefix}/perf_sensor`} element={<PerfSensor/>}/> {/* 센서 장비 */}
          <Route path={`/${prefix}/perf_system`} element={<PerfSystem/>}/> {/* 시스템 */}
          <Route path={`/${prefix}/perf_broker-server`} element={<PerfBrokerServer/>}/> {/* 브로커서버 */}
          {/*삭제예정<Route path={`/${prefix}/perf_gateway`} element={<PerfGateway/>}/>  게이트웨이 */}
          {/*삭제예정<Route path={`/${prefix}/perf_repeater`} element={<PerfRepeater/>}/>  중계기 */}

          {/* 트래픽 관리 */}
          <Route path={`/${prefix}/traf_abnormal`} element={<TrafAbnormal/>}/> {/* 이상 트래픽 */}
          <Route path={`/${prefix}/traf_transmit-receive-history`} element={<TrafHistory/>}/> {/* 송수신 이력 */}

          {/* 사용자 관리 */}
          <Route path={`/${prefix}/user_auth`} element={<UserAuth/>}/> {/* 사용자등록 (인증)*/}
          <Route path={`/${prefix}/user_access-history`} element={<UserAccessHistory/>}/> {/* 권한관리 (접근 권한 이력) */}
          <Route path={`/${prefix}/user_topic`} element={<UserTopic/>}/> {/* MQTT 사용자 (토픽) */}
          <Route path={`/${prefix}/user_manager`} element={<UserSafetyManager/>}/>{/* 시설안전관리자 */}
          <Route path={`/${prefix}/user_accreditation`} element={<UserPermission/>}/> {/* 인가 */}

          {/* 시스템 관리 */}
          <Route path={`/${prefix}/sys_firmware`} element={<SysFirmware/>}/> {/* 센서 및 무선장비 (펌웨어) */}
          <Route path={`/${prefix}/sys_sms-settings`} element={<SysSmsSettings/>}/> {/* SMS 전송 설정 */}
          <Route path={`/${prefix}/sys_sms-history`} element={<SysSmsHistory/>}/> {/* SMS 전송 이력 */}
          <Route path={`/${prefix}/sys_119-history`} element={<Sys119History/>}/> {/* 타시스템연동 (119 신고 이력) */}
          <Route path={`/${prefix}/sys_fclty-dept`} element={<SysFcltyDept/>}/> {/* 화재안전관리자 */}
          <Route path={`/${prefix}/sys_report`} element={<SysReport/>}/> {/* 일일운영일지 (보고서) */}
        </Routes>
      </BrowserRouter>
  );
};

export default AppV2;